import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];
  const resource = properties.resource || 'document';
  const operation = properties.operation || 'get';

  // Index is required for most operations
  if (resource === 'document' || ['create', 'delete', 'get'].includes(operation)) {
    if (!properties.indexId || properties.indexId.trim() === '') {
      errors.push({
        key: 'indexId',
        message: 'Index is required',
      });
    }
  }

  // Document ID required for single document operations
  if (resource === 'document' && ['delete', 'get', 'update'].includes(operation)) {
    if (!properties.documentId || properties.documentId.trim() === '') {
      errors.push({
        key: 'documentId',
        message: 'Document ID is required',
      });
    }
  }

  // Validate query JSON if provided
  if (properties.options?.query) {
    try {
      JSON.parse(properties.options.query);
    } catch {
      errors.push({
        key: 'options.query',
        message: 'Query must be valid JSON',
      });
    }
  }

  // Validate sort JSON if provided
  if (properties.options?.sort && properties.options.sort.trim() !== '') {
    try {
      JSON.parse(properties.options.sort);
    } catch {
      errors.push({
        key: 'options.sort',
        message: 'Sort must be valid JSON',
      });
    }
  }

  // Validate fields for create/update with defineBelow
  if (
    resource === 'document' &&
    ['create', 'update'].includes(operation) &&
    properties.dataToSend === 'defineBelow'
  ) {
    const fields = properties.fieldsUi?.values || [];
    if (fields.length === 0) {
      errors.push({
        key: 'fieldsUi',
        message: 'At least one field is required',
      });
    }

    fields.forEach((field: any, index: number) => {
      if (!field.fieldId || field.fieldId.trim() === '') {
        errors.push({
          key: `fieldsUi.values[${index}].fieldId`,
          message: 'Field name is required',
        });
      }
    });
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
